export default "__VITE_ASSET__D1T$7DGj__"